import React from 'react';
import { gtagReportConversion } from '../utils/gtag';

/**
 * Reusable conversion tracking link component
 * 
 * Usage:
 * <ConversionLink href="https://buy.stripe.com/xxx" className="btn btn-primary">
 *   Get Access
 * </ConversionLink>
 */
function ConversionLink({ href, children, className = '', onClick, ...props }) {
  const handleClick = (e) => {
    e.preventDefault();
    
    // Call custom onClick if provided
    if (onClick) {
      onClick(e);
    }
    
    // Track conversion and redirect
    gtagReportConversion(href);
  };

  return (
    <a href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}

export default ConversionLink;
